// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel-item[data-v-4baede9d]{--height-offset:140px;height:calc(100vh - 140px);height:calc(100vh - var(--height-offset))}.carousel-item__loader[data-v-4baede9d]{left:50%;position:absolute;top:50%;transform:translate(-50%)}.carousel-item__image[data-v-4baede9d]{max-width:100%;-o-object-fit:contain;object-fit:contain}@media only screen and (max-width:959px){.carousel-item[data-v-4baede9d]{--height-offset:200px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
